module.exports = __webpack_public_path__ + "img/second.87551b79.jpg";